import axios from './axios'
import Offer from '@/model/offer'
import GrainWanted from '@/model/grain-wanted'

export default {
  async getOffers (type) {
    return await axios.get('/offer', { type: type })
  },
  async createOffer (offer) {
    const sanitisedOffer = Offer.sanitiseModel(offer)
    return await axios.post('/offer/create', sanitisedOffer)
  },
  async updateOffer (offer) {
    const sanitisedOffer = Offer.sanitiseModel(offer)
    return await axios.put('/offer/update', sanitisedOffer)
  },

  async getOpenOffers (params) {
    // const params = {
    //   numberOfItems: numberOfItems, 
    //   page: page, 
    //   grain: grain, [{name: '', grades: [{name: ''}]}]
    //   storage: storage, 
    //   offerType: offerType, 
    //   state: state, 
    //   region: region
    // }

    console.log('getOpenOffers', params)

    const result = await axios.post('/offer/open-list', params, {unsecured: true})
    Offer.setClasses(result.data)
    return result
  },
  async getOffer (lot) {
    console.log('getOffer: ', lot)
    const result = await axios.get('/offer/' + lot, {unsecured: true})
    return Offer.setClass(result)
  },
  async getMyOffers (numberOfItems, page, openOnly = true, orgId) {
    const params = {
      numberOfItems: numberOfItems,
      page: page,
      openOnly: openOnly,
      orgId: orgId,
    }
    const result = await axios.get('/offer/org-offer-list', {params: params})
    Offer.setClasses(result.data)
    return result
  },
  /*
  async updateOffer (offerId, quantity, price, offerType, isPublic) {
    const params = {
      offerId: offerId,
      offerType: offerType,
      price: price,
      quantity: quantity,
      isPublic: isPublic
    }
    const result = await axios.put('/offer', params)
    return Offer.setClass(result.offer)
  },*/
  async withdraw (offerId, reason) {
    const params = {
      offerId: offerId,
      reason: reason
    }
    const result =  await axios.put('/offer/withdraw', params)
    return Offer.setClass(result.offer)
  },

  async getGrainWanted () {
    const result = await axios.get('/offer/watch-list', {unsecured: true})
    GrainWanted.setClasses(result)
    return result
  },
  async getGrainWantedPlus () {
    const result = await axios.get('/offer/watch-list-plus')
    GrainWanted.setClasses(result)
    return result
  },

}
